<script setup>
// VicTech #710:转真人提醒(无画面元件)。挂在 App.vue,登入且有 account 时运作:
// 标题 (N) 前缀 + favicon 红点 + 新转真人响一次提示音。N 的定义见 tracker.js。
import { onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { NeedHumanController } from './controller';
import { TitleBadge } from './title';
import { FaviconBadge } from './favicon';
import { AlertSound } from './sound';
import { fetchNeedHumanIds } from './api';
import { needHumanState } from './state';

const props = defineProps({
  accountId: { type: [Number, String], default: null },
});

const store = useStore();
let controller = null;
let warnedBlocked = false;

const stop = () => {
  if (controller) controller.stop();
  controller = null;
};

const startFor = accountId => {
  stop();
  needHumanState.accountId = accountId;
  needHumanState.count = 0;
  needHumanState.ready = false;
  if (!accountId) return;
  controller = new NeedHumanController({
    store,
    fetchIds: () => fetchNeedHumanIds(),
    title: new TitleBadge(document),
    favicon: new FaviconBadge(document),
    sound: new AlertSound({
      onBlocked: () => {
        if (warnedBlocked) return;
        warnedBlocked = true;
        useAlert(
          'Need human: click anywhere on this page once to enable the alert sound.'
        );
      },
    }),
    // VicTech #710-kimi:即时事件只认本 agent 可见的收件箱(agent 的收件箱清单由伺服器按成员资格给;管理员=全部)
    allowedInboxIds: () => {
      const list = store.getters['inboxes/getInboxes'];
      return Array.isArray(list) && list.length
        ? new Set(list.map(inbox => String(inbox.id)))
        : null;
    },
    onCount: (n, ready) => {
      needHumanState.count = n;
      needHumanState.ready = ready;
    },
  });
  // 测试/排障用:在 console 看 window.victechNeedHuman
  window.victechNeedHuman = { state: needHumanState, controller };
  controller.start();
};

watch(() => props.accountId, startFor, { immediate: true });
onBeforeUnmount(stop);
</script>

<template>
  <span class="hidden" data-test-id="victech-need-human-alerts" />
</template>
